import viaCEP from './viaCEP'

export default {
  viaCEP,
}
